import { Slider } from "components/Slider";
import { ServiceSliderCard } from "./ServiceSliderCard";

import "./ServiceSlider.scss";

interface ServiceSliderProps {
  prevRef: React.RefObject<HTMLButtonElement>;
  nextRef: React.RefObject<HTMLButtonElement>;
  branches: any;
}

export function ServiceSlider({
  prevRef,
  nextRef,
  branches,
}: ServiceSliderProps) {
  return (
    <Slider
      prevRef={prevRef}
      nextRef={nextRef}
      customButtons
      slidesPerView={4}
      className="service-slider"
      sliderData ={[
        branches?.map((branch: any) => (
          <ServiceSliderCard
            key={branch?.id}
            workingTime={branch?.working_time}
            address={branch?.address}
            title={branch?.title}
            email={branch?.email}
            location={branch?.region}
          />
        )),
      ]}
    />
  );
}
